import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconChannelCeltra = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 40 40"
    >
      <g
        transform="translate(2.5, 0)"
        fill="#000"
      >
        <path d="M9.48438 19.9599C9.48438 13.8367 13.2219 9.18457 19.3651 9.18457C23.8581 9.18457 27.4367 11.8088 27.7349 16.0633H24.7528C24.4546 13.5186 22.3671 11.8685 19.5241 11.8685H19.2259C14.8919 11.8685 12.4864 15.4669 12.4864 19.94C12.4864 24.4331 14.872 28.0116 19.2259 28.0116H19.5241C22.3671 28.0116 24.4546 26.3615 24.7528 23.8168H27.7349C27.4367 28.0713 23.8383 30.6955 19.3651 30.6955C13.2219 30.7154 9.48438 26.0832 9.48438 19.9599Z" />
        <path d="M34.4732 37.3159H0V39.9998H34.4732V37.3159Z" />
        <path d="M34.473 0H9.5625V2.6839H34.473V0Z" />
        <path d="M2.6839 0H0V30.4175H2.6839V0Z" />
      </g>
    </SvgIcon>
  ))
);
IconChannelCeltra.displayName = 'IconChannelCeltra';
